<template>
  <div class="entry">
    <keep-alive>
      <router-view class="container" />
    </keep-alive>
    <tabbar
      class="tabbar"
      v-model="active"
      :z-index="999"
      active-color="#E74C3C"
      inactive-color="#404040"
      safe-area-inset-bottom
      :before-change="beforeChange"
      route
    >
      <tabbar-item
        v-for="(tabbar, index) in tabbarList"
        :key="index"
        :name="tabbar.name"
        :to="tabbar.path"
        replace
      >
        <img
          :src="props.active ? tabbar.icon.activeIcon : tabbar.icon.icon"
          slot="icon"
          slot-scope="props"
        />
        {{ tabbar.title }}
      </tabbar-item>
    </tabbar>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from 'vant'
export default {
  name: 'entry',
  components: {
    Tabbar,
    TabbarItem
  },
  data () {
    return {
      active: 'home',
      tabbarList: [
        {
          title: '个人入口',
          path: '/home',
          name: 'home',
          icon: {
            icon: require('../assets/img/home-change/home.png'),
            activeIcon: require('../assets/img/home-change/home-active.png')
          },
          isLogin: false
        },
        {
          title: '企业慧采',
          path: `/company`,
          name: 'company',
          icon: {
            icon: require('../assets/img/home-change/icon-company.png'),
            activeIcon: require('../assets/img/home-change/icon-company-active.png')
          },
          isLogin: false
        },
        // {
        //   title: '分类',
        //   path: '/classify',
        //   name: 'classify',
        //   icon: {
        //     icon: require('../assets/img/home-change/categray.png'),
        //     activeIcon: require('../assets/img/home-change/categray-active.png')
        //   },
        //   isLogin: false
        // },
        // {
        //   title: '消息',
        //   path: '/message',
        //   name: 'message',
        //   icon: {
        //     icon: require('../assets/img/home-change/message.png'),
        //     activeIcon: require('../assets/img/home-change/message-active.png')
        //   },
        //   isLogin: false
        // },
        {
          title: '购物车',
          path: '/shopingTrolley',
          name: 'shopingTrolley',
          icon: {
            icon: require('../assets/img/home-change/cart.png'),
            activeIcon: require('../assets/img/home-change/cart-active.png')
          },
          isLogin: true
        },

        {
          title: '我的',
          path: '/personalCenter',
          name: 'personalCenter',
          icon: {
            icon: require('../assets/img/home-change/my.png'),
            activeIcon: require('../assets/img/home-change/my-active.png')
          },
          isLogin: true
        }
      ]
    }
  },
  methods: {
    beforeChange (name) {
      if (name === 'company') {
        // if (!this.Authorization) {
        //   this.$toast('请先登录')
        //   this.$router.push({ name: 'login' })
        //   return false
        // }
        location.href = `${process.env.VUE_APP_BASE_URL}qyhc`
        return false
      } else {
        return true
      }
    }
  }
}
</script>
<style lang="less">
.van-tabbar-item > .van-tabbar-item__icon {
  width: 0.45rem !important;
  height: 0.45rem !important;
}
.van-tabbar-item > .van-tabbar-item__icon > img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>

<style lang="less" scoped>
.entry {
  .safe-area-inset-bottom;
}
.container {
  padding-bottom: 1rem !important;
}
.tabbar {
  height: 1rem;
}
.van-tabbar-item {
  font-size: 0.22rem;
}
</style>
